import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Survey } from '../../../models/roiSurvey/survey';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  readonly rootUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }


  ceckRequest(module, analisiId): Observable<any> {
    let data = '?module=' + module + '&analisiId=' + analisiId;
    return this.http.get(this.rootUrl + '/api/Modules/checkrequest' + data);
  }

  moduleRequest(module, facilityId, elaborazioneId): Observable<any> {
    let data = '?module=' + module + '&facilityId=' + facilityId + "&elaborazioneId=" + elaborazioneId;
    return this.http.get(this.rootUrl + '/api/Modules/request' + data);
  }

  moduleRead(facilityId, elaborazioneId, module): Observable<any> {
    const body = {
      "facilityId": facilityId,
      "elaborazioneId": elaborazioneId,
      "module": module
    };
    return this.http.post(this.rootUrl + '/api/Modules/read', body);
  }

  moduleDownload(facilityId, elaborazioneId, module): Observable<any> {
    const body = {
      "facilityId": facilityId,
      "elaborazioneId": elaborazioneId,
      "module": module
    };
    return this.http.post(this.rootUrl + '/api/Modules/download', body);
  }

  getSurvey(facilityId, elaborazioneId, CurrentPage, ItemsPage): Observable<any> {
    let data = '?facilityId=' + facilityId + '&elaborazioneId=' + elaborazioneId + "&CurrentPage=" + CurrentPage + "&ItemsPage=" + ItemsPage;
    return this.http.get(this.rootUrl + '/api/Modules/getsurvey' + data);
  }

  saveSurvey(surveyRoi: Survey): Observable<any> {
    const body = surveyRoi;
    return this.http.post(this.rootUrl + '/api/Modules/savesurvey', body);
  }

}
